/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../../app/dialog/dialog.actions';
import { scoreSelectors } from '../../../../../../../app/resource/score/score.selectors';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { IScoreRowProps } from './types';
import { UserCell } from './UserCell';

import Pause from '../../../../../../resources/images/pause.svg';
import { deleteScore } from '../../../../../../../app/page/page-storage/kpi/kpi.actions';
import { IScore } from '../../../../../../../app/resource/score/score.types';

export const ScoreRow: FunctionComponent<IScoreRowProps> = ({
  scoreId,
  filterId,
  onCheckboxChange,
  isSelected = false,
}) => {
  const dispatch = useDispatch();
  const score = useSelectWithParams(scoreSelectors.selectResourceById, scoreId) as IScore;

  const [checked, setChecked] = useState(isSelected);

  useEffect(() => {
    setChecked(isSelected);
  }, [isSelected]);

  const openScoreForm = useCallback(() => {
    if (score) {
      dispatch(openDialog('scoreFormDialog', { meetingId: score.meetingId, score }));
    }
  }, [dispatch, score]);
  const openScoreCloneForm = useCallback(() => {
    if (score) {
      const clonedScore = { ...score, id: '' };
      dispatch(openDialog('scoreFormDialog', { meetingId: score.meetingId, clone: true, score: clonedScore }));
    }
  }, [dispatch, score]);

  const onDeleteScore = useCallback(() => {
    if (score) {
      dispatch(deleteScore(score.id));
    }
  }, [dispatch, score]);

  const handleCheckboxChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.stopPropagation();
      const newChecked = !checked;
      setChecked(newChecked);
      if (onCheckboxChange) {
        onCheckboxChange(scoreId, newChecked);
      }
    },
    [checked, onCheckboxChange, scoreId],
  );

  const scoreValue = Number(score?.score || 0).toLocaleString();
  const shouldRender = filterId === '' ? true : score.userId === filterId ? true : false;

  return (
    score && (
      <div className="flex-table align-center" role="rowgroup" style={{ display: shouldRender ? '' : 'none' }}>
        <div className="flex-row scorecard" role="cell" onClick={(e) => e.stopPropagation()} style={{ width: '5%' }}>
          <input
            type="checkbox"
            id={`checkbox-${score.id}`}
            onChange={handleCheckboxChange}
            checked={checked}
            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
          />
          <label htmlFor={`checkbox-${score.id}`}></label>
        </div>
        <div className="flex-row" role="cell">
          <UserCell userId={score.userId} meetingId={score.meetingId} />
        </div>
        <div className="flex-row f-14" role="cell">
          {score.title}
        </div>
        <div className="flex-row flex aic" role="cell">
          <span className="round-icon-small mr-1">{score.goal}</span>
          <div className="account-item-desc">
            <h3 className="account-item-title">
              {score.units === '$' ? `${score.units}${scoreValue}` : `${scoreValue} ${score.units}`}
            </h3>
          </div>
        </div>
        <div className="flex-row aic jcr last" role="cell">
          <a className="round-icon-small mr-1" onClick={openScoreCloneForm}>
            <img src={Pause} className="img-fluid" />
          </a>
          <a className="round-icon-small mr-1 popup_button" data-popup="new_password_popup" onClick={openScoreForm}>
            <i className="icon-pencil" />
          </a>
          <a className="round-icon-small mr-0 popup_button" data-popup="delete_popup" onClick={onDeleteScore}>
            <i className="icon2-trash" />
          </a>
        </div>
      </div>
    )
  );
};
